import request from '@/utils/request3'
import store from '@/store'
// const serviceName ='/prod/user-management-service'
const serviceName = store.state.serviceName.managementService
const workServiceName = store.state.serviceName.workOrder

//部门根据类型获取维度表 包括该类型下的所有子维度
// export function getDimTableCharAndChildrenByType(data) {
//     return request({
//         url: serviceName + `/dim-table/getDimTableCharAndChildrenByType?type=${data.type}&parentId=${data.parentId}`,
//         method: 'get',
//     })
// }

//根据输入的维表类型列出该类型下的所有编码与名称
export function getAllDict(type) {
    return request({
        url: serviceName + `/dim-table/getDimTableByType/${type}`,
        method: 'get',
    })
}
//获取项目ID-项目名称,下拉框内容,自己的项目ID
export function getAllMyProject(type) {
    return request({
        url: serviceName + `/dim-table/my_project`,
        method: 'get',
    })
}

//查询所有技术人员
export function getQueryAllTeacher() {
    return request({
        url: serviceName + `/user/queryAllTeacher`,
        method: 'get',
    })
}

//查询所有销售
export function getQueryAllSales() {
    return request({
        url: serviceName + `/user/queryAllSales`,
        method: 'get',
    })
}

//根据传入id获取指定部门信息
export function getDimTableDeptByIds(data) {
    return request({
        url: serviceName + `/work-order/getDeptByIds?ids=${data}`,
        method: 'get',
    })
}

//工单文件url下载附件
export function download(data) {
    return request({
        url: workServiceName + `/file/download?fileUrl=${data}`,
        method: 'get',
        responseType: 'blob'
    })
}
